<template>
  <div class="container-body" :style="{width: width}">
    <button :id="id" class="am-accordion" :style="{width: width}">{{ header }}</button>
      <div class="am-accordion-panel">
        <div class="am-accordion-main-table">
          <table class="am-accordion-table">
            <thead>
            <tr>
              <slot name="columns">
                <th v-for="column in columns">
                  {{column}}
                </th>
              </slot>
            </tr>
            </thead>
            <tbody>
            <template v-for="item in items">
              <tr>
                <slot :item="item">
                  <td v-for="column in columns"
                      v-if="hasValue(item, column)">
                    {{itemValue(item, column)}}
                  </td>
                </slot>
              </tr>
              <slot name="expandedView"  v-if="checkActiveLogView(item, logViewItems)" :logViewItemsRow="item"></slot>
            </template>
            </tbody>
          </table>
        </div>
      </div>
  </div>
</template>

<script>
  import ViewLogs from "./Finance/ViewLogs";
  export default {
    name: 'Accordion',
    components: {
      ViewLogs
    },
    data() {
      return {
        id: this.uuid()
      }
  },
  mounted () {
    let acc = document.getElementById(this.id)

    acc.addEventListener('click', function () {
      this.classList.toggle('am-active')
      let panel = this.nextElementSibling
      if (panel.style.maxHeight) {
        panel.style.maxHeight = null
      } else {
        panel.style.maxHeight = '100%'
      }
    })
    if(this.isOpen){
      acc.click();
    }
  },

        props: {
            header: String,
            width: {
                type: String,
            },
            columns: Array,
            items:{
                type: Array,
                default: () => []
            },
            isOpen: {
              type: Boolean,
              default: false
            },
            logViewItems: {
                type: Array,
                default: () => []
            },
            logViewItemsRow: {
                type: Array,
                default: () => []
            }
        },

  methods: {
    hasValue (item, column) {
      return item[column.toLowerCase()] !== 'undefined'
    },
    itemValue (item, column) {
      return item[column.toLowerCase()]
    },
    uuid() {
      return ([1e7]+-1e3+-4e3+-8e3+-1e11).replace(/[018]/g, c =>
        (c ^ crypto.getRandomValues(new Uint8Array(1))[0] & 15 >> c / 4).toString(16)
      );
    },
    checkActiveLogView(item, logViewItems){
      if(logViewItems && logViewItems.includes(item.id)){
          this.row = logViewItems
          return true
      } else {
          return false
      }
    }
  }
}
</script>

<style scoped>
  .am-accordion {
    background-color: #2777A3;
    color: #ffffff;
    cursor: pointer;
    padding: 8px;
    margin: 0 auto;
    border: none;
    text-align: left;
    outline: none;
    font-size: 12px;
    font-weight: 700;
    -webkit-transition: 0.4s;
    -o-transition: 0.4s;
    transition: 0.4s;
  }

  .am-active, .am-accordion:hover {
    background-color: #87bb00;
  }

  .am-accordion:after {
    content: '\25B6';
    color: #ffffff;
    font-weight: bold;
    font-size: 8px;
    float: left;
    margin: 3px 8px 0px 5px;
  }

  .am-active:after {
    content: "\25BC";
  }

  .am-accordion-panel {
    background-color: white;
    max-height: 0;
    overflow: hidden;
    -webkit-transition: max-height 0.2s ease-out;
    -o-transition: max-height 0.2s ease-out;
    transition: max-height 0.2s ease-out;
    margin-bottom: 0;
    margin-top: 1px;
  }

  .container-body {
    margin: 0 auto;
    padding: 0;
  }

  .am-accordion-main-table {
    padding: 5px;
    border: 1px solid #A6C9E2;
  }

  .am-accordion-table {
    width: 100%;
  }

  .am-accordion-table tbody tr:nth-child(odd) {
    background-color: #ECECEC;
  }

  .am-accordion-table tbody tr:nth-child(even) {
    background-color: #F4F4F4;
  }

  .am-accordion-table thead {
    background-color: #444444;
    color: white;
  }

  .am-accordion-table td {
    font-size: 11px;
  }

  .am-accordion-table th {
    font-size: 11px;
  }
</style>
